export default {
  header: 'Denne uge',
  metrics: {
    points: 'Point',
    visits: 'Besøg',
    in_store_sign_ups: 'Tilmeldinger i butik',
    rewards_redeemed: 'Indløste belønninger',
  },
};
